import Image from "next/image";
import React, { Component } from "react";
import { useTranslations } from '../../locales/useTranslations';

const ÜberunsDigitaleTransformation = () => {
  const { t } = useTranslations();
  return (
    <section className="about-area ptb-100 bg-f4f6fc">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6 col-md-12">
            <div className="about-content">
              <span className="sub-title">{t('about_digitalTransformation_subtitle')}</span>
              <h2>{t('about_digitalTransformation_title')}</h2>
              <p dangerouslySetInnerHTML={{ __html: t('about_digitalTransformation_paragraph1') }} />
              <p dangerouslySetInnerHTML={{ __html: t('about_digitalTransformation_paragraph2') }} />
              <p dangerouslySetInnerHTML={{ __html: t('about_digitalTransformation_paragraph3') }} />
            </div>
          </div>

          <div className="col-lg-6 col-md-12">
            <div className="about-image">
              <Image src="/images/about/steps.webp" alt="simplify data - teamwork in projekten"
                width={0}
                height={0}
                sizes="100vw"
                style={{ width: '100%', height: 'auto' }} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ÜberunsDigitaleTransformation;
